// global.service.ts

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalNumberNotificationsService {
  public numberNotifications: number = 0;
}